// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"b9bb4220","129":"bf69568b","213":"85035ec8","493":"b0d28051","667":"45a0a3f1"}[chunkId] + ".chunk.js";
};